export const iosimProgressResultsMock = {
  expectedDuration: 300,
  simulationStatus: '2',
  startSimulationTime: 'Wed, 14 Jun 2017 07:00:00 GMT',
};
